import * as styles from "./ColorPickerArrow.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { Popover as BasePopover } from "@base-ui/react/popover";

import { useColorPickerContext } from "./ColorPicker.context";
import type { ColorPickerArrowProps } from "./ColorPicker.types";

export function ColorPickerArrow({
  className,
  style,
  ...props
}: ColorPickerArrowProps): JSX.Element {
  const { size } = useColorPickerContext();

  return (
    <BasePopover.Arrow
      data-slot="color-picker-arrow"
      className={clsx(styles.arrow({ size }), className)}
      style={{ left: "50%", transform: "translateX(-50%)", ...style }}
      {...props}
    />
  );
}
